import { render, staticRenderFns } from "./dv-release-modal.vue?vue&type=template&id=5d0a58c0&scoped=true&"
import script from "./dv-release-modal.vue?vue&type=script&lang=js&"
export * from "./dv-release-modal.vue?vue&type=script&lang=js&"
import style0 from "./dv-release-modal.vue?vue&type=style&index=0&id=5d0a58c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0a58c0",
  null
  
)

export default component.exports